<template>
  <div id="UpLoadFile">
    <ul class="upLoadImgListBox" v-if="isSubmit">
      <draggable
        group="article"
        class="upLoadImgList"
        :value="fileList"
        @input="handleListChange($event)"
      >
        <li
          class="upLoadImgBox"
          @click="removeItem(item)"
          v-for="(item,index) in fileList"
          :key="item"
        >
          <div class="closeBox">
            <!-- <el-avatar shape="square" :src="item"></el-avatar> -->
            <img
              style="width:100px; height:85px"
              @click.stop="handleCheckOutImgItem(item,index)"
              :src="item"
            />
            <i class="el-icon-circle-close closeIcon" @click.stop="removeItem(item)"></i>
          </div>
        </li>
      </draggable>
      <li class="addUpLoadBtn">
        <!-- <el-upload drag class="upload-demo" action="#" :before-upload="handleBefore">
          <el-button size="small" type="primary">
            <img src="../assets/image/icon_sc@2x.png" alt />
            点击上传文件
          </el-button>
        </el-upload>-->
        <el-upload
          drag
          class="upload-demo"
          action="https://upload-z2.qiniup.com"
          multiple
          :data="postData"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          :on-error="handleError"
        >
          <el-button size="small" type="primary">
            <img src="../assets/image/icon_sc@2x.png" alt />
            点击上传文件
          </el-button>
        </el-upload>
      </li>
    </ul>
    <ul class="upLoadImgList" v-else>
      <li
        @click="handleCheckOutImgItem(item,index)"
        class="upLoadImgBox noClose"
        v-for="(item,index) in fileList"
        :key="item"
      >
        <div class="closeBox">
          <img style="width:100px; height:85px" :src="item" />
        </div>
      </li>
    </ul>

    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia showImgDetailsZ"
      :append-to-body="true"
    >
      <div class="diaContainer">
        <img style="display:block;width:80%;margin:0 auto;" :src="showImg" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from 'echarts'
import { Loading } from 'element-ui' //项目已经全局引入element的话可以不单独引入
import { api as viewerApi } from 'v-viewer'
import Draggable from 'vuedraggable'

export default {
  data() {
    return {
      token: '',
      member_id: '',
      fileList: [],
      showImg: '',
      showDetailsDia: false,
      // 七牛上传相关
      postData: {
        token: '',
        key: '',
      },
      isShow: true,
      loadingData: [],
      upload_qiniu_addr: 'http://qiniu.sxpz.vip/',
    }
  },
  props: ['imgList', 'isSubmit'],
  components: {
    Draggable,
  },
  methods: {
    // 拖拽上传
    handleListChange(event) {
      // this.imgList = event
      this.fileList = event
      this.$emit('my-upload-change', this.fileList)
      console.log(this.fileList)
    },
    showImgDetails(url) {
      this.showImg = url
      this.showDetailsDia = true
    },
    removeItem(val) {
      let removeIndex = this.fileList.findIndex((item) => item == val)
      this.fileList.splice(removeIndex, 1)
      this.$emit('my-upload-change', this.fileList)
    },

    // *七牛云上传
    // 获取七牛云token
    async getQiniuToken() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      const res = await this.$axios({
        method: 'post',
        url: '/api/Qiniu/qiniuToken',
        data: param,
      })
      if (res.status != 200) {
        return this.$message('获取七牛云上传token失败')
      }
      this.postData.token = res.data
      // console.log('this.postData', res.data)
    },
    // 上传成功(七牛云)
    handleAvatarSuccess(res, file) {
      var imageUrl = this.upload_qiniu_addr + res.key
      this.fileList.push(imageUrl)
      this.endLoading(file.name)
      this.$emit('my-upload-change', this.fileList)
    },
    fileUpload() {},
    // 上传前(七牛云)
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        return this.$message.error('上传图片大小不能超过 500MB!')
      }
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)

      const whiteList = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'JPG',
        'JPEG',
        'PBG',
        'GIF',
        'BMP',
      ]

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error('上传文件只能是 图片文件')
        return false
      }
      this.postData.key =
        new Date().getTime().toString() +
        Math.random(6).toString() +
        '.' +
        file.name.split('.')[file.name.split('.').length - 1]
      console.log('***before', this.loadingData)
      this.startLoading(file.name)
    },
    // 上传失败(七牛云)
    handleError() {
      this.$message.error('文件上传失败')
      this.errorend()
    },
    // 加载动画
    startLoading(name) {
      let a = Loading.service({
        name: name,
        lock: true,
        text: '上传中……',
        background: 'rgba(255, 255, 255, .9)',
      })
      this.loadingData.push(a)
    },
    endLoading(name) {
      console.log(name)
      this.loadingData.forEach((item) => {
        if (item.name == name) {
          item.close()
          item = null
        }
      })
    },
    errorend() {
      this.loadingData.forEach((item) => {
        item.close()
        item = null
      })
    },
    // 组建展示图片
    handleCheckOutImgItem(val, index) {
      console.log('imgList', this.imgList)
      const $viewer = viewerApi({
        options: {
          toolbar: true,
          // url: 'url',
          initialViewIndex: index,
          tooltip: true,
          fullscreen: true,
          keyboard: true,
          zIndex: 9999,
        },
        images: this.imgList,
      })
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.getQiniuToken()
    this.loadingData = []
    console.log(this.isSubmit)
  },
  mounted() {
    if (this.imgList) {
      this.imgList.forEach((item) => {
        this.fileList.push(item)
      })
    }
  },
  watch: {
    imgList(val, oldVal) {
      //普通的watch监听
      if (val) {
        this.fileList = val
      }
    },
  },
}
</script>
<style lang="less" scoped>
#UpLoadFile {
  // 上传图片组件
  .upLoadImgList {
    display: flex;
    flex-wrap: wrap;
    .upLoadImgBox {
      width: 100px;
      height: 85px;
      margin-right: 15px;
      margin-bottom: 15px;
      .closeBox {
        width: 100%;
        height: 100%;
        position: relative;
        .closeIcon {
          display: none;
          cursor: pointer;
          font-size: 20px;
          color: #128bf1;
          position: absolute;
          right: -5px;
          top: -5px;
        }
      }
      /deep/.closeBox:hover .closeIcon {
        display: block !important;
      }

      /deep/.el-avatar--square {
        width: 100% !important;
        height: 100% !important;
        border-radius: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .upLoadImgBox {
      width: 100px;
      height: 85px;
      margin-right: 15px;
      margin-bottom: 15px;
      .closeBox {
        width: 100%;
        height: 100%;
        position: relative;
        .closeIcon {
          display: none;
          cursor: pointer;
          font-size: 20px;
          color: #128bf1;
          position: absolute;
          right: -5px;
          top: -5px;
        }
      }
      /deep/.closeBox:hover .closeIcon {
        display: block !important;
      }

      /deep/.el-avatar--square {
        width: 100% !important;
        height: 100% !important;
        border-radius: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .addUpLoadBtn {
      height: 85px;
      display: flex;
      align-items: flex-end;
      .upload-demo {
        height: 25px;
        align-items: center;
      }
    }
  }
  .upload-demo {
    display: flex;
    align-items: flex-end;
    /deep/.el-button {
      padding: 0;
      border: none;
      background-color: #fff;
      color: #128bf1;
      font-size: 14px;
      font-weight: normal;
      img {
        width: 19px;
        height: 14px;
      }
    }
  }
}
/deep/.el-icon-upload-success {
  display: none;
}
/deep/.el-upload-list {
  display: none;
}
</style>